import React, { useEffect, useState } from "react";
import "./OtherTasksViewLight.css";

import ClickNHold from "react-click-n-hold";
import GeneralTaskPopup from "../GeneralTask/GeneralTaskPopup";
import Tabs from "../Tabs/Tabs";

export default function OtherTasksViewLight({
  date,
  generalTaskArr,
  initialPanels,
}) {
  const [generalTasksDaily, setGeneralTasksDaily] = useState([]);
  const [generalTasksWeekly, setGeneralTasksWeekly] = useState([]);
  const [generalTasksMonthly, setGeneralTasksMonthly] = useState([]);

  const [filteredPanels, setFilteredPanels] = useState([]);

  useEffect(() => {
    const panelsVisibility = window.GlobalData.getGeneralTaskPanelsVisibility();

    const newFilteredPanels = initialPanels.filter((panel) => {
      const isVisible = panelsVisibility.find((p) => p.Id === panel.Id)
        ? panelsVisibility.find((p) => p.Id === panel.Id).isVisible
        : true;

      return isVisible;
    });

    setFilteredPanels(newFilteredPanels);
  }, [initialPanels]);

  const panels = filteredPanels.sort((a, b) => {
    const usernameComparison = a.UserName.localeCompare(b.UserName);
    if (usernameComparison !== 0) {
      return usernameComparison;
    }
    return a.SortOrder - b.SortOrder;
  });

  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    const savedSelectedTab = window.localStorage.getItem(
      "GeneralTasksSelectedPanel"
    );

    if (!savedSelectedTab || !panels[savedSelectedTab]) {
      return;
    }

    try {
      setSelectedTab(parseInt(savedSelectedTab));
    } catch (ex) {
      console.error("Error setting selected tab", ex);
    }
  }, [initialPanels]);

  useEffect(() => {
    setGeneralTasksDaily(generalTaskArr?.filter((task) => task.tasktype == 1));
    setGeneralTasksWeekly(generalTaskArr?.filter((task) => task.tasktype == 2));
    setGeneralTasksMonthly(
      generalTaskArr?.filter((task) => task.tasktype == 3)
    );
  }, [generalTaskArr]);

  const onCellHoldCLick = (task) => {
    let task_aux = { ...task };
    task_aux.Color = task.Color == "red" ? "green" : "red";

    task_aux.Flag = "Update";
    task_aux["ConnectionId"] = window.notification.connectionId;

    window.DataGate.insertOrUpdateGeneralTask(task_aux, (code, data) => {
      if (code == window.DataGate.CODE_OK) {
        window.training.refresh({ showSpinner: false });
      }
    });
  };

  const renderGeneralTaskTableDaily = () => {
    const currentTasks = generalTasksDaily.filter(
      (item) => item.PanelId == panels[selectedTab].Id
    );
    return (
      <div>
        <table
          className="riderTableR otherTasksViewTable"
          style={{ maxWidth: "350px" }}
        >
          <thead>
            <tr>
              <td colSpan={3}>Other tasks</td>
            </tr>
          </thead>
          <tbody>
            {currentTasks &&
              currentTasks.map((i, index) => (
                <tr key={index}>
                  <td
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => onGeneralTaskClick(i, 1)}
                  >
                    <ClickNHold
                      time={1.5}
                      onClickNHold={() => {
                        onCellHoldCLick(i);
                      }}
                    >
                      <div>
                        <div style={{ fontSize: "0.6em" }}>{i.TimeOfDay}</div>
                        <span
                          className="otherTasksViewTable--task-name"
                          style={
                            i.Color == "green"
                              ? {
                                  fontWeight: "bold",
                                  textDecoration: "line-through",
                                  textShadow: "none",
                                }
                              : {
                                  fontWeight: "bold",
                                  color: "red",
                                }
                          }
                        >
                          {window.DataStorage.allUsers.length
                            ? i.TrainerId
                              ? i.Name +
                                " (" +
                                window.getInitials(
                                  window.DataStorage.allUsers.find(
                                    (t) => t.Id == i.TrainerId
                                  ).Name
                                ) +
                                ")"
                              : i.Name + "(N)"
                            : i.Name}
                        </span>
                        <div style={{ fontSize: "0.6em" }}>{i.Remark}</div>
                      </div>
                    </ClickNHold>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };
  const renderGeneralTaskTableWeekly = () => {
    const currentTasks = generalTasksWeekly.filter(
      (item) => item.PanelId == panels[selectedTab].Id
    );
    return (
      <div>
        <table className="riderTableR otherTasksViewTable">
          <thead>
            <tr>
              <td colSpan={3}>Weekly tasks</td>
            </tr>
          </thead>
          <tbody>
            {currentTasks &&
              currentTasks.map((i, index) => (
                <tr key={index}>
                  <td
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => onGeneralTaskClick(i, 2)}
                  >
                    <ClickNHold
                      time={1.5}
                      onClickNHold={() => {
                        onCellHoldCLick(i);
                      }}
                    >
                      <div>
                        <div style={{ fontSize: "0.6em" }}>{i.TimeOfDay}</div>
                        <span
                          className="otherTasksViewTable--task-name"
                          style={
                            i.Color == "green"
                              ? {
                                  fontWeight: "bold",
                                  textDecoration: "line-through",
                                  textShadow: "none",
                                }
                              : {
                                  fontWeight: "bold",
                                  color: "red",
                                }
                          }
                        >
                          {window.DataStorage.allUsers.length
                            ? i.TrainerId
                              ? i.Name +
                                " (" +
                                window.getInitials(
                                  window.DataStorage.allUsers.find(
                                    (t) => t.Id == i.TrainerId
                                  ).Name
                                ) +
                                ")"
                              : i.Name + "(N)"
                            : i.Name}
                        </span>
                        <div style={{ fontSize: "0.6em" }}>{i.Remark}</div>
                      </div>
                    </ClickNHold>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };
  const renderGeneralTaskTableMonthly = () => {
    const currentTasks = generalTasksMonthly.filter(
      (item) => item.PanelId == panels[selectedTab].Id
    );
    return (
      <div>
        <table className="riderTableR otherTasksViewTable">
          <thead>
            <tr>
              <td colSpan={3}>Monthly tasks</td>
            </tr>
          </thead>
          <tbody>
            {currentTasks &&
              currentTasks.map((i, index) => (
                <tr key={index}>
                  <td
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => onGeneralTaskClick(i, 3)}
                  >
                    <ClickNHold
                      time={1.5}
                      onClickNHold={() => {
                        onCellHoldCLick(i);
                      }}
                    >
                      <div>
                        <div style={{ fontSize: "0.6em" }}>{i.TimeOfDay}</div>
                        <span
                          className="otherTasksViewTable--task-name"
                          style={
                            i.Color == "green"
                              ? {
                                  fontWeight: "bold",
                                  textDecoration: "line-through",
                                  textShadow: "none",
                                }
                              : {
                                  fontWeight: "bold",
                                  color: "red",
                                }
                          }
                        >
                          {window.DataStorage.allUsers.length
                            ? i.TrainerId
                              ? i.Name +
                                " (" +
                                window.getInitials(
                                  window.DataStorage.allUsers.find(
                                    (t) => t.Id == i.TrainerId
                                  ).Name
                                ) +
                                ")"
                              : i.Name + "(N)"
                            : i.Name}
                        </span>
                        <div style={{ fontSize: "0.6em" }}>{i.Remark}</div>
                      </div>
                    </ClickNHold>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };

  const onGeneralTaskClick = (task, taskType) => {
    let options = {
      date: new Date(task.Time),
      simplified: true,
    };
    new GeneralTaskPopup().showPopup(options, task, () => {});
  };

  const tabs = panels.map((panel) => {
    return { title: panel.UserName + " 's " + panel.Name };
  });

  return (
    <div className="otherTasksViewHolderWrapper">
      <Tabs
        tabs={tabs}
        selected={selectedTab}
        onChange={(newVal) => {
          window.localStorage.setItem("GeneralTasksSelectedPanel", newVal);
          setSelectedTab(newVal);
        }}
      />
      <div className="otherTasksViewHolder otherTasksViewHolderScrollArea">
        <div style={{ flex: 1, maxWidth: "350px" }}>
          {renderGeneralTaskTableDaily()}
        </div>
        <div style={{ flex: 1, maxWidth: "350px" }}>
          {renderGeneralTaskTableWeekly()}
        </div>
        <div style={{ flex: 1, maxWidth: "350px" }}>
          {renderGeneralTaskTableMonthly()}
        </div>
      </div>
    </div>
  );
}
